export default function Home() {
  return (
    <section className='home'>
      <h1>Hi, I’m Luis.</h1>
      <p>I’m a lead backend software engineer with extensive experience building and scaling e-commerce platforms using Ruby on Rails. I specialize in system architecture, API design, performance optimization, and mentoring engineering teams.</p>
      <p>I hold a PhD in Nuclear Physics and a bachelor’s degree in Astronomy, bringing strong analytical thinking and problem-solving skills to software engineering.</p>
      <p>Outside of work, I’m deeply passionate about drum and bass music, live events, and professional wrestling.</p>
    </section>
  );
}